import { useState } from "react";

interface SecurityPaymentBannerProps {
  className?: string;
  variant?: "default" | "footer";
}

export const SecurityPaymentBanner = ({ className = "", variant = "default" }: SecurityPaymentBannerProps) => {
  const [imageError, setImageError] = useState(false);
  const imagePath = "/images/security-payment-banner.png";
  const isFooter = variant === "footer";

  // Try to load the image, fallback to styled component if not found
  if (!imageError) {
    return (
      <div className={`flex items-center justify-center ${className}`}>
        <img
          src={imagePath}
          alt="Sécurité 3D Secure - Payzone, Visa, Mastercard"
          className={`max-w-full h-auto ${isFooter ? "max-h-12 sm:max-h-14" : "max-h-16 sm:max-h-20"} object-contain`}
          onError={() => setImageError(true)}
          loading="lazy"
        />
      </div>
    );
  }

  // Fallback styled version if image doesn't load
  return (
    <div className={`flex flex-wrap items-center justify-center gap-3 sm:gap-4 ${className}`}>
      {/* Security Icon and Text */}
      <div className="flex items-center gap-2 sm:gap-3">
        <div className="relative">
          <svg
            className={`${isFooter ? "w-5 h-5 sm:w-6 sm:h-6 text-white" : "w-6 h-6 text-blue-600"}`}
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z" />
          </svg>
        </div>
        <span className={`text-xs sm:text-sm font-medium ${isFooter ? "text-white" : "text-gray-700"}`}>
          Ce site web est sécurisé 3D Secure
        </span>
      </div>

      {/* Payment Logos */}
      <div className="flex items-center gap-2 sm:gap-3">
        {/* Payzone Logo */}
        <div className="flex items-center gap-1">
          <span className={`text-xs sm:text-sm font-bold ${isFooter ? "text-white" : "text-blue-600"}`}>Pay</span>
          <span className={`text-xs sm:text-sm font-bold ${isFooter ? "text-white" : "text-pink-500"}`}>zone</span>
          <span className={`text-[8px] sm:text-[10px] ${isFooter ? "text-white" : "text-gray-500"}`}>®</span>
        </div>

        {/* Visa Logo */}
        <div className={`flex items-center justify-center ${isFooter ? "bg-white/10" : "bg-blue-50"} rounded px-2 py-1`}>
          <span className={`text-xs sm:text-sm font-bold ${isFooter ? "text-white" : "text-blue-600"}`}>VISA</span>
        </div>

        {/* Mastercard Logo */}
        <div className="flex items-center gap-1">
          <div className="flex">
            <div className={`w-4 h-4 sm:w-5 sm:h-5 rounded-full ${isFooter ? "bg-red-500" : "bg-red-600"} -mr-2`}></div>
            <div className={`w-4 h-4 sm:w-5 sm:h-5 rounded-full ${isFooter ? "bg-orange-500" : "bg-orange-600"}`}></div>
          </div>
          <span className={`text-[8px] sm:text-[10px] font-medium ${isFooter ? "text-white" : "text-gray-700"}`}>mastercard</span>
        </div>
      </div>
    </div>
  );
};

